import logoBlue from "@/assets/logo/wasteking-logo-blue-220x55.png";
import logoGrey from "@/assets/logo/wasteking-logo-grey-220x55.png";
import logoRed from "@/assets/logo/wasteking-logo-red-220x55.png";
import logoWhite from "@/assets/logo/wasteking-logo-white-220x55.png";
import welcomeOne from "@/assets/welcome/welcome-01.png";
import welcomeTwo from "@/assets/welcome/welcome-02.png";

const brandCover = new URL("../../branding/1.png", import.meta.url).href;
const brandColours = new URL("../../branding/8.png", import.meta.url).href;

export const wasteKingAssets = {
  logos: {
    blue: logoBlue,
    grey: logoGrey,
    red: logoRed,
    white: logoWhite,
  },
  welcome: {
    recycling: welcomeOne,
    focus: welcomeTwo,
  },
  brandGuide: {
    cover: brandCover,
    colours: brandColours,
  },
};
